import { Action, createAction, props } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GithubContext, GithubSyncDialogData } from './github-contract.types';

export abstract class GithubFacade {
  static Actions = {
    datasetEditorHeaderGithubSyncInitialized: createAction('[Dataset Editor Header] Github Sync Initialized'),
    reportEditorHeaderGithubSyncInitialized: createAction('[Report Editor Header] Github Sync Initialized'),
    definitionEditorHeaderGithubSyncInitialized: createAction(
      '[Definition Editor Header] Github Sync Initialized',
      props<{ context$: Observable<GithubContext | null> }>()
    ),
    datasetEditorHeaderPushedChangesToGithub: createAction('[Dataset Editor Header] Pushed changes to Github'),
    reportEditorHeaderPushedChangesToGithub: createAction('[Report Editor Header] Pushed changes to Github'),
    definitionEditorHeaderPushedChangesToGithub: createAction('[Definition Editor Header] Pushed changes to Github'),
    workspaceSettingsPushedChangesToGithub: createAction(
      '[workspace Settings] Pushed changes to Github',
      props<{ dialogData: GithubSyncDialogData }>()
    ),
  };
  public abstract dispatch(action: Action): void;

  abstract readonly canSyncToGithub$: Observable<boolean>;
  abstract readonly githubLink$: Observable<string | null | undefined>;
  abstract readonly lastSynchedAt$: Observable<Date | undefined>;
  abstract readonly hasUnsyncedChanges$: Observable<boolean>;
}
